import apiClient from '@shared/config/axiosConfig';
import fileService from './filesService';
import { buildScanReportFileName } from '@shared/lib/scanReportName';

// Crear un reporte escaneado subiendo un PDF.
// nombreContext aporta los nombres (planta y tipo de mantenimiento) para construir
// el nombre de archivo estandarizado; no se envía al backend.
const crearReporteEscaneado = async (reporteData, archivo, nombreContext = {}) => {
    try {
        console.log('Iniciando creación de reporte escaneado...');
        console.log('Datos del reporte:', reporteData);
        console.log('Archivo:', archivo?.name, archivo?.size, archivo?.type);

        // Nombre estandarizado: fecha_semana_tipoMantenimiento_planta
        const customFileName = buildScanReportFileName({
            fechacreacion: reporteData.fechacreacion,
            tipomantenimiento: nombreContext.tipomantenimiento,
            nombreplanta: nombreContext.nombreplanta,
            originalName: archivo?.name,
        });

        // Primero subir el archivo usando el servicio de archivos
        const resultadoArchivo = await fileService.uploadFile(archivo, 'reportes-escaneados', customFileName);
        console.log('Archivo subido exitosamente:', resultadoArchivo);

        // Crear el reporte con el path del archivo
        const datosReporte = {
            ...reporteData,
            scanPath: resultadoArchivo.key // El path del archivo en el servidor
        };

        const response = await apiClient.post('/reportes-escaneados', datosReporte);
        return response.data;
    } catch (error) {
        console.error('Error al crear reporte escaneado:', error);
        throw error;
    }
};

// Obtener todos los reportes escaneados
const obtenerReportesEscaneados = async () => {
    try {
        const response = await apiClient.get('/reportes-escaneados');
        return response.data;
    } catch (error) {
        console.error('Error al obtener reportes escaneados:', error);
        throw error;
    }
};

// Obtener reportes escaneados por planta
const obtenerReportesEscaneadosPorPlanta = async (idPlanta) => {
    try {
        const response = await apiClient.get(`/reportes-escaneados/planta/${idPlanta}`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener reportes escaneados por planta:', error);
        throw error;
    }
};

// Obtener URL para visualizar el PDF
// Parámetro: puede ser un id de reporte (numérico) o directamente un scanPath (string con slash)
const obtenerUrlVisualizacion = async (idOrScanPath) => {
    try {
        // Si parece ser un scanPath (contiene '/' o termina en .pdf), obtener URL directamente
        if (typeof idOrScanPath === 'string' && (idOrScanPath.includes('/') || idOrScanPath.toLowerCase().endsWith('.pdf'))) {
            const url = await fileService.getImage(idOrScanPath);
            if (!url) throw new Error('No se encontró URL para el scanPath');
            return { success: true, data: { url } };
        }

        // En caso contrario, asumimos que es un id de reporte y pedimos al backend
        const response = await apiClient.get(`/reportes-escaneados/${idOrScanPath}`);
        const reporte = response.data;

        if (!reporte || !reporte.scanPath) {
            throw new Error('El reporte no tiene un archivo asociado');
        }

        const url = await fileService.getImage(reporte.scanPath);
        if (!url) throw new Error('No se pudo obtener la URL del archivo');

        return { success: true, data: { url } };
    } catch (error) {
        console.error('Error al obtener URL de visualización:', error);
        return { success: false, message: error.message };
    }
};

// Eliminar reporte escaneado
const eliminarReporteEscaneado = async (idReporte) => {
    try {
        const response = await apiClient.delete(`/reportes-escaneados/${idReporte}/eliminar`);
        return response.data;
    } catch (error) {
        console.error('Error al eliminar reporte escaneado:', error);
        throw error;
    }
};

const reportesEscaneadosService = {
    crearReporteEscaneado,
    obtenerReportesEscaneados,
    obtenerReportesEscaneadosPorPlanta,
    obtenerUrlVisualizacion,
    eliminarReporteEscaneado
};

export default reportesEscaneadosService;